import { render, staticRenderFns } from "./Last30DaysActivity.vue?vue&type=template&id=112ff6cc&"
import script from "./Last30DaysActivity.vue?vue&type=script&lang=ts&"
export * from "./Last30DaysActivity.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports